// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.action-list[data-v-44c38664] {\n  margin-left: -0.75rem;\n}\n", ""]);
// Exports
module.exports = exports;
